import { useTranslate } from '@im/react-localization';
import { XClose } from '@im/ui-lib/zenith/icons';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import React, { FC, useState } from 'react';
import ConfirmationDialog from 'src/components/ConfirmationDialog/ConfirmationDialog';

export interface DialogFormProps {
  onClose: () => void;
  openDialog: boolean;
}

export interface DialogWrapperProps {
  children: JSX.Element;
  dialogTitle: string;
  disabled: boolean;
  isFormUpdated: boolean;
  onClose: () => void;
  onSubmit: () => void;
  open: boolean;
}

const DialogWrapper: FC<DialogWrapperProps> = ({
  children,
  dialogTitle,
  disabled,
  isFormUpdated,
  onClose,
  onSubmit,
  open,
}) => {
  const translate = useTranslate();
  const [openConfirmationDialog, setOpenConfirmationDialog] =
    useState<boolean>(false);

  return (
    <>
      <Dialog fullWidth open={open}>
        <DialogTitle>
          <Typography
            sx={{ fontSize: '18px', fontWeight: 600, lineHeight: '28px' }}
          >
            {dialogTitle}
          </Typography>
          <IconButton
            onClick={() =>
              isFormUpdated ? setOpenConfirmationDialog(true) : onClose()
            }
          >
            <XClose />
          </IconButton>
        </DialogTitle>
        <DialogContent>{children}</DialogContent>
        <DialogActions sx={{ justifyContent: 'space-between' }}>
          <Button
            fullWidth
            onClick={() =>
              isFormUpdated ? setOpenConfirmationDialog(true) : onClose()
            }
            variant="newOutlined"
          >
            {translate('Common.Cancel')}
          </Button>
          <Button
            disabled={disabled}
            fullWidth
            onClick={onSubmit}
            variant="newContained"
          >
            {translate('Common.Confirm')}
          </Button>
        </DialogActions>
      </Dialog>
      <ConfirmationDialog
        buttons={[
          {
            children: translate('Common.Close'),
            key: 'cancel',
            onClick: () => {
              setOpenConfirmationDialog(false);
            },
            variant: 'newOutlined',
          },
          {
            children: translate('Common.Yes'),
            key: 'yes',
            onClick: () => {
              setOpenConfirmationDialog(false);
              onClose();
            },
            variant: 'newContained',
          },
        ]}
        content={translate('Common.DiscardConfirmationContent')}
        open={openConfirmationDialog}
        title={translate('Common.DiscardConfirmationTitle')}
      />
    </>
  );
};

export default DialogWrapper;
